import { withWatermark } from "@/lib/utils";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star, CheckCircle2 } from "lucide-react";
import { fetchReviewInfo, submitReview } from "@/lib/api";

export default function ReviewPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { fetchReviewInfo(token).then(setInfo).catch((e) => setError(e?.response?.data?.detail || "Lien invalide ou expire")); }, [token]);

  const submit = async () => {
    if (!rating) return;
    setBusy(true);
    try { await submitReview(token, { rating, comment }); setDone(true); }
    catch (e) { setError(e?.response?.data?.detail || "Erreur"); }
    finally { setBusy(false); }
  };

  const Shell = ({ children }) => <main className="max-w-md mx-auto px-4 py-8" data-testid="review-page">{children}</main>;
  if (error) return <Shell><div className="glass-card p-8 text-center text-red-600 font-bold" data-testid="review-error">{error}</div></Shell>;
  if (!info) return <Shell><div className="glass-card p-8 text-center">Chargement...</div></Shell>;
  if (done || info.already_reviewed) return (
    <Shell><div className="glass-card p-8 text-center" data-testid="review-done">
      <CheckCircle2 size={44} className="mx-auto text-emerald-600 mb-3" />
      <div className="font-display text-2xl font-extrabold">Merci pour votre avis !</div>
      <p className="mt-2 text-[var(--ink-soft)] text-sm">Il est publie avec le badge « Avis verifie » sur la fiche de {info.hotel?.name}.</p>
    </div></Shell>
  );
  return (
    <Shell>
      <div className="glass-card overflow-hidden">
        {info.hotel?.image && <img src={withWatermark(info.hotel.image)} alt={info.hotel.name} className="w-full h-32 object-cover" />}
        <div className="p-5">
          <div className="text-xs uppercase tracking-widest text-[var(--ink-soft)]">Avis verifie · sejour du {info.reservation.date}</div>
          <h1 className="font-display text-2xl font-extrabold mt-1" data-testid="review-hotel">{info.hotel?.name}</h1>
          <div className="mt-5 flex justify-center gap-2" data-testid="review-stars">
            {[1, 2, 3, 4, 5].map((n) => (
              <button key={n} type="button" onClick={() => setRating(n)} className="p-1" data-testid={`review-star-${n}`} aria-label={`${n} etoiles`}>
                <Star size={38} className={n <= rating ? "fill-amber-400 text-amber-400" : "text-[var(--line)]"} />
              </button>
            ))}
          </div>
          <textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={4} placeholder="Votre commentaire (facultatif)" className="mt-4 w-full" data-testid="review-comment" />
          <button onClick={submit} disabled={!rating || busy} className="btn-primary w-full mt-4 !py-3" data-testid="review-submit">{busy ? "Envoi..." : "Publier mon avis"}</button>
        </div>
      </div>
    </Shell>
  );
}
